import { render, staticRenderFns } from "./ZeigeBuKundenHerstellerUmsaetze.vue?vue&type=template&id=b9fe777a&"
import script from "./ZeigeBuKundenHerstellerUmsaetze.vue?vue&type=script&lang=js&"
export * from "./ZeigeBuKundenHerstellerUmsaetze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports